import { UserInfo } from "src/context/AppContext";
import { mapRequestingCompanyResponseToRequestingCompany } from "../ChangeRequest/helpers";
import { mapFiles, removeSupplyDocumentTypes } from "../helper";
import { RemoveSupplyComputedStatusEnum } from "../../Changes/types";
import { RemoveSupplyFormValues } from "./types";

export const mapDraftServiceToFormikValues = (
  data: any
): RemoveSupplyFormValues => {
  console.log(data);
  const {
    services: [service],
    premise,
  } = data;

  const draftPayload = JSON.parse(service.payload) as any;

  const abolishmentForm = mapFiles(
    service.attachments_meta ?? [],
    removeSupplyDocumentTypes
  );

  return {
    requester: service?.requestor,
    submittedDateTime: service?.submitted_date_time
      ? new Date(service.submitted_date_time)
      : undefined,
    // Mappable fields
    nmi: service.nmi_mirn ?? "",
    mirn: service.nmi_mirn ?? "",
    requestingCompany: premise?.site_details?.requesting_company
      ? mapRequestingCompanyResponseToRequestingCompany(
          premise.site_details.requesting_company
        )
      : null,
    noCompany: !premise?.site_details?.requesting_company,
    premise,
    energyType: "electricity",

    abolishmentDate: draftPayload.scheduledDate
      ? new Date(draftPayload.scheduledDate)
      : null,
    abolishmentForm,

    supplyServiceOrderNumber: service.supply_service_order_number ?? null,
    networkFormNumber: service.network_form_number ?? null,
    requesterName: service.requestor ?? null,
    requesterEmail: service.requestor_email ?? null,
    channel: service.channel ?? null,
    accountHolderRequest:
      service.request_status ===
      RemoveSupplyComputedStatusEnum.VERIFICATION_COMPLETED
        ? "Received"
        : null,
  };
};

export const getPayerDetails = ({
  noCompany,
  user,
}: {
  noCompany: boolean;
  user: UserInfo;
}) => {
  return {
    payerType: noCompany ? "RESIDENTIAL" : "COMMERCIAL",
    firstName: user.first_name,
    lastName: user.last_name,
    phoneNumber: null, //BE will populate it
    emailAddress: user.email,
  };
};
